import * as React from "react";
import { useCallback, useState } from "react";
import {
  PointerSensor,
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  MouseSensor,
  TouchSensor,
  KeyboardSensor
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
  sortableKeyboardCoordinates
} from "@dnd-kit/sortable";
import ListItemDragOverlay from "components/common/SortableList/ListItemDragOverlay";
import List from "./List";
const SortableList = ({
  alignItemContent = void 0,
  customContentRender = void 0,
  customListItemRender = void 0,
  disableDragging = false,
  displayOverlayInPortal = false,
  fullWidth = false,
  items = [],
  onMoveItem
}) => {
  const [activeId, setActiveId] = useState(null);
  const sensors = useSensors(
    useSensor(MouseSensor, {}),
    useSensor(TouchSensor, {}),
    useSensor(PointerSensor, {}),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );
  const handleDragStart = useCallback((event) => {
    setActiveId(event.active.id);
  }, []);
  const handleDragEnd = useCallback(
    ({ active, over }) => {
      setActiveId(null);
      if (!over || active.id === over.id) {
        return;
      }
      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);
      if (oldIndex !== -1 && newIndex !== -1 && oldIndex !== newIndex) {
        const newList = arrayMove(items, oldIndex, newIndex);
        onMoveItem(newList, oldIndex, newIndex);
      }
    },
    [items, onMoveItem]
  );
  return /* @__PURE__ */ React.createElement(
    DndContext,
    {
      collisionDetection: closestCenter,
      onDragEnd: handleDragEnd,
      onDragStart: handleDragStart,
      sensors
    },
    /* @__PURE__ */ React.createElement(SortableContext, { items: items.map((item) => item.id), strategy: verticalListSortingStrategy }, /* @__PURE__ */ React.createElement("div", { style: { width: fullWidth ? "100%" : void 0 } }, /* @__PURE__ */ React.createElement(
      List,
      {
        alignItemContent,
        customContentRender,
        customListItemRender,
        disableDragging,
        items
      }
    )), /* @__PURE__ */ React.createElement(
      ListItemDragOverlay,
      {
        activeId,
        alignItemContent,
        customContentRender,
        customListItemRender,
        displayOverlayInPortal,
        items
      }
    ))
  );
};
export default SortableList;
